const base = import.meta.env.BASE_URL;

export function RoutingVisual() {
  return <div className="service-demo routing-demo" aria-hidden="true">
    <span className="demo-caption">คำถาม → ดำเนินการ</span>
    <div className="demo-message"><img src={`${base}logos/gmail.svg`} alt="" /><div><b>คำถามใหม่</b><span>พร้อมส่งต่อ</span></div></div>
    <div className="demo-connector"><i /></div>
    <div className="demo-rule">มอบหมายและติดตาม</div>
    <div className="demo-connector"><i /></div>
    <div className="demo-destinations"><span><img src={`${base}logos/hubspot.svg`} alt="" />CRM <i>✓</i></span><span><img src={`${base}logos/slack.svg`} alt="" />ทีม <i>✓</i></span></div>
  </div>;
}

export function AiVisual() {
  return <div className="service-demo extraction-demo" aria-hidden="true">
    <span className="demo-caption">เอกสาร → ตรวจทาน</span>
    <div className="demo-document"><span>เอกสารเข้า</span><b>ใบแจ้งหนี้</b><div className="demo-document-lines"><i /><i /><i /></div><div className="demo-scan" /></div>
    <div className="demo-extraction"><span>ดึงข้อมูลแล้ว <i>✓</i></span><b>พร้อมให้คนตรวจทาน</b></div>
  </div>;
}

export function ProcessVisual() {
  return <div className="service-demo approvals-demo" aria-hidden="true">
    <span className="demo-caption">คำขอ → อนุมัติ</span>
    <div className="demo-request"><span>คำขอซื้อ</span><b>ส่งให้ฝ่ายปฏิบัติการ</b></div>
    <ol className="demo-approval-steps">{['รับคำขอแล้ว', 'เจ้าของงานตรวจ', 'อนุมัติให้ดำเนินการ'].map((step, index) => <li key={step} style={{ animationDelay: `${index * 2}s` }}><span>{index === 2 ? '✓' : index + 1}</span><b>{step}</b></li>)}</ol>
  </div>;
}

export function AppVisual() {
  return <div className="service-demo app-demo" aria-hidden="true">
    <span className="demo-caption">งานของคุณ → แอปของคุณ</span>
    <div className="demo-app-window"><div className="demo-app-header"><span className="demo-app-mark">A</span><b>พื้นที่ทำงานของทีม</b><span>↗</span></div>
      <div className="demo-app-body"><div className="demo-app-sidebar"><i /><i /><i /></div><div className="demo-app-content"><b>คำขอ</b><div className="demo-app-row"><span>คำถามใหม่</span><i>มอบหมาย</i></div><div className="demo-app-row"><span>คำขอซื้อ</span><i>ตรวจทาน</i></div><div className="demo-app-row"><span>ส่งต่องาน</span><i>พร้อม ✓</i></div></div></div>
    </div><div className="demo-app-footer"><span>แดชบอร์ด</span><span>พอร์ทัล</span><span>เครื่องมือภายใน</span></div>
  </div>;
}
